<div class="order-card-container d-flex flex-column position-relative padding-for-16-9">
  <div class="details-container p-3 center-absolutely">
    <div class="date-info">
      <div class="date-heading">{{pickupHeading}}</div>
      <div class="date-time">{{pickupDate}}</div>
    </div>
    <div class="order-status-info">
      <div class="status-info-header">{{statusInfoHeader}}</div>
      <div class="status-info-text">{{statusInfoText}}</div>
    </div>
  </div>
</div>